import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import Agents from './pages/Agents';
import AgentDetail from './pages/AgentDetail';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProperties from './pages/admin/AdminProperties';
import AdminPropertyForm from './pages/admin/AdminPropertyForm';
import AdminLocations from './pages/admin/AdminLocations';
import AdminAgents from './pages/admin/AdminAgents';
import AdminAgentForm from './pages/admin/AdminAgentForm';
import AdminBlog from './pages/admin/AdminBlog';
import AdminBlogForm from './pages/admin/AdminBlogForm';
import AdminDevelopers from './pages/admin/AdminDevelopers';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminInquiries from './pages/admin/AdminInquiries';
import AdminSettings from './pages/admin/AdminSettings';
import { Toaster } from './components/ui/toaster';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SiteProvider } from './context/SiteContext';

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-neutral-500">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Routes>
              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                <Route index element={<AdminDashboard />} />
                <Route path="properties" element={<AdminProperties />} />
                <Route path="properties/new" element={<AdminPropertyForm />} />
                <Route path="properties/:id" element={<AdminPropertyForm />} />
                <Route path="locations" element={<AdminLocations />} />
                <Route path="agents" element={<AdminAgents />} />
                <Route path="agents/new" element={<AdminAgentForm />} />
                <Route path="agents/:id" element={<AdminAgentForm />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="blog/new" element={<AdminBlogForm />} />
                <Route path="blog/:id" element={<AdminBlogForm />} />
                <Route path="developers" element={<AdminDevelopers />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="inquiries" element={<AdminInquiries />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              {/* Public */}
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/properties" element={<PublicLayout><Properties /></PublicLayout>} />
              <Route path="/properties/:transactionType" element={<PublicLayout><Properties /></PublicLayout>} />
              <Route path="/properties/:transactionType/:type" element={<PublicLayout><Properties /></PublicLayout>} />
              <Route path="/property/:id" element={<PublicLayout><PropertyDetail /></PublicLayout>} />
              <Route path="/agents" element={<PublicLayout><Agents /></PublicLayout>} />
              <Route path="/agent/:id" element={<PublicLayout><AgentDetail /></PublicLayout>} />
              <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
              <Route path="/blog/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
              <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
              <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            </Routes>
            <Toaster />
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
